const Role = {
  ADMIN: "admin",
  REVIEWER: "reviewer",
  USER: "user",
 };
export default Role;
